import PurchaseLedgerDayBookCriteriaModal from '../../components/modals/PurchaseLedgerDayBookCriteriaModal';

import { IWorkspaceAction } from '../../@types/workspaceTypes';
import React, { ReactElement, useState } from 'react';

enum PurchaseTransactionWorkspaceActions {
  PURCHASE_DAYBOOK = 'Sales Daybook',
}

export const workspaceActionsForPermissions = [
  {
    actionReference: PurchaseTransactionWorkspaceActions.PURCHASE_DAYBOOK,
  },
];

export const usePurchaseTransactionWorkspaceActions = (): [actions: Array<IWorkspaceAction>, modals: ReactElement] => {
  const [daybookOpen, setDaybookOpen] = useState(false);

  const actions: Array<IWorkspaceAction> = [
    {
      actionReference: PurchaseTransactionWorkspaceActions.PURCHASE_DAYBOOK,
      key: 'purchase_daybook',
      text: 'Purchase Daybook',
      onClick: () => setDaybookOpen(true),
      ignoreBulkActionCheck: true, //This report does not use workspace selections.
    },
  ];

  return [
    actions,
    <>
      <PurchaseLedgerDayBookCriteriaModal isOpen={daybookOpen} onClose={() => setDaybookOpen(false)} />
    </>,
  ];
};
